import { getTrackingKey } from '@/utils/api'

import API from './base'

class DeepIntegrationAPI extends API {
  authenticateByCheckoutId = (checkoutId) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'CHECKOUT-ID_token'),
      path: this.uri + `/${checkoutId}/token`,
    })
  }
}

export default new DeepIntegrationAPI('/checkout')
